<template>
  <div>
    <div v-if="$route.path == '/HardWare/hardWareList'">
      <el-form :model="formInline" class="toolbar">
        <el-row type="flex" class="row-bg" :gutter="10">
          <el-col :span="5">
            <el-form-item label="">
              <el-input v-model="query.ModelNum" placeholder="设备序列号"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="">
              <el-input v-model="query.BrandId" placeholder="品牌"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="">
              <el-input v-model="query.SchoolName" placeholder="幼儿园"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="">
              <el-input v-model="query.AgentName" placeholder="代理商"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="">
              <el-select v-model="query.Status" placeholder="全部状态">
                <el-option v-for="(item,index) in statusList" :key="item.id" :label="item.text" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="">
              <el-select v-model="query.IMEI" placeholder="尺寸">
                <el-option v-for="(item,index) in sizeList" :key="item.id" :label="item.text" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
  
        </el-row>
        <el-row type="flex" class="row-bg">
          <el-form-item>
            <area-select ref="areaForm" v-model="areaInfo" label="所属区域" label-width="100px" :areaIsHide="false" style="margin-bottom:0px"></area-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onQuerySubmit" icon="search">查询</el-button>
            <el-button type="primary" @click="onQueryClean(query)" icon="delete2">重置</el-button>
          </el-form-item>
        </el-row>
      </el-form>
  
      <div>
        <el-table :data="lists" v-loading="loading2" element-loading-text="拼命加载中" border style="width: 100%;" router>
          <el-table-column label="设备序列号" prop="IMEI" width="150">
          </el-table-column>
          <el-table-column label="品牌" prop="ProBrand" width="100">
          </el-table-column>
          <el-table-column label="尺寸" prop="HardType" width="100">
          </el-table-column>
          <el-table-column label="所属项目" prop="ProjuectName" width="200">
          </el-table-column>
          <el-table-column label="所属代理商" prop="AgentName" width="150">
          </el-table-column>
          <el-table-column label="所属区域" prop="BusUser" width="150">
          </el-table-column>
          <el-table-column label="幼儿园信息">
            <el-table-column prop="SchoolName" label="学校" width="200">
            </el-table-column>
            <el-table-column prop="ClassList" label="班级" width="240">
            </el-table-column>
            <!--<el-table-column prop="GradeName" label="年级" width="120">-->
            <!--</el-table-column>-->
            <!--<el-table-column prop="ClassName" label="班级" width="100">-->
            <!--</el-table-column>-->
          </el-table-column>
          <el-table-column label="绑定时间" prop="BindTime" width="150">
          </el-table-column>
          <el-table-column label="状态" prop="Status" width="100">
          </el-table-column>
          <el-table-column label="操作" width="240px" fixed="right">
            <template scope="scope">
              <!--<el-button size="small" @click="handleView(scope.$index, scope.row)" icon="view" type="success">查看</el-button>-->
              <el-button size="small" @click="" icon="check" :disabled="(scope.row.btnVue&128)<=0" type="primary">退回</el-button>
              <el-button size="small" @click="" icon="close" :disabled="(scope.row.btnVue&64)<=0" type="danger">锁定</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-col :span="24" class='btm-action'>
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="query.pageIndex" :page-sizes="pageSizes" :page-size="query.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalSize*1" style="float: right">
        </el-pagination>
      </el-col>
    </div>
    <div v-else>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import { lg, util } from 'utils';
import { GetT_HardwareByPage, MAP_STATUS_LIST, MAP_SIZE_LIST } from '@api/hardWareApi';
import areaSelect from 'area-select';
import NProgress from 'nprogress';

let session = util.getSessin();

export default {
  data() {
    return {
      formInline: {
        user: '',
        region: ''
      },
      lists: [],
      totalSize: '',
      sels: [],//列表选中列
      SaleCheckView: false,
      pageSizes: [10, 20, 50],
      loading2: false,
      statusList: MAP_STATUS_LIST,
      sizeList: MAP_SIZE_LIST,
      query: {
        Sid: "",
        Session: this.sysSession,
        pageIndex: 1,
        pageSize: 10,
        total: 0,
        orderBy: "",
        Status: "",
        IMEI: "",
        BrandId: "",
        ModelNum: "",
        AgentName: "",
        ProvId: "",
        CityId: "",
        SchoolName: ""
      },
      areaInfo: {
        Provinces_Id: '',
        City_Id: '',
        Area_Id: ''
      }
    }
  },

  watch: {
    query: {
      deep: true,
      handler(curVal, oldVal) {
        this.areaInfo.Provinces_Id = curVal.ProvId;
        this.areaInfo.City_Id = curVal = curVal.CityId;
      }
    },
    areaInfo: {
      deep: true,
      handler(curVal, oldVal) {
        this.query.ProvId = curVal.Provinces_Id;
        this.query.CityId = curVal.CityId;
      }
    },
    '$route'(to, from) {
      if (this.$route.path == '/HardWare/hardWareList') {
        this.getList();
      }
    }
  },
  components: {
    areaSelect: areaSelect
  },
  methods: {
    //分页选定行
    handleSizeChange: function (val) {
      this.query.pageSize = val;
      this.getDataList();
    },
    //分页监听dd页面
    handleCurrentChange: function (val) {
      this.query.pageIndex = val;
      this.getDataList();
    },
    getDataList() {
      this.lists = [];
      this.loading2 = true;//拼命加载中显示
      GetT_HardwareByPage(util.getFormSearchParams(this.query)).then(res => {
        util.doResult(this, res, () => {});
        let { StateCode, StateMsg, Data, Cnt } = res.data;
        if (StateCode !== 0 && StateCode !== 99) {
          this.$notify({
            title: '错误',
            message: StateMsg,
            type: 'error'
          });
        } else {
          this.query.total = Cnt;
          this.loading2 = false;//拼命加载中隐
          this.lists = Data;
        }
      });
    },
    //查询
    onQuerySubmit() {
      this.query.pageIndex = 1;
      this.getDataList();
    },
    //重置查询条件
    onQueryClean: function (formQuery) {
      util.resetFormQueryParam(formQuery);
      this.$refs.areaForm.resetFields();
      this.getDataList();
    },
    handleView() {
      //alert("");
    }
  },
  created() {
    var user = sessionStorage.getItem("user");
    if (user) {
      user = JSON.parse(user);
      this.query.Sid = user.Sid || '';
      this.query.Session = user.Session || '';
    }
    this.getDataList();
  }
}
</script>

<style scoped lang="scss">

</style>





// WEBPACK FOOTER //
// hardWareList.vue?688316b4